// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d27f895b","453":"14a57fb2"}[chunkId] + ".chunk.js";
};